import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class ProdutoService extends CRUDService{
    constructor() {
        super("produto");
    }

    listFatosGeradores() {
        return http.get("/produto/fatogerador");
    }

    /**
     * [HttpGet]
     * [Route("/produto/codigo/{codigo:string}")]
     * 
     * @param codigo : Código do projeto/centro de resultado/finalidade MOT.
     * 
     * Retorna um Produto específico através da propriedade Produto.codigo.
     */
    findByCodigo(codigo) {
        return http.get("/produto/codigo/" + codigo);
    }

    listAll() {
        return http.get("/produto");
    }

    listByJustificativa(justificativaId) {
        return http.get("/"+this.serviceName+"/substituicao/justificativa/"+justificativaId);
    }

    listByJustificativaSubstituicaoPorSolicitacao(solicitacaoId, solicitacaoEttId, removeAtual, ignoraFiltroJustificativa) {
        return http.get("/"+this.serviceName+"/substituicao/justificativa/solicitacao/"+solicitacaoId+"/"+solicitacaoEttId + "?removerAtual=" + removeAtual+ "&ignoraFiltroJustificativa="+ ignoraFiltroJustificativa);
    }

    listProdutosIntegracao() {
        return http.get("/produto/integracao");
    }

    listByPrefixoDescricaoEbsECodigo(prefixo, codigo) {
        return http.get("/integracao/ebs/produtos/"+encodeURIComponent(prefixo)+"/"+encodeURIComponent(codigo));
    }

    listByPrefixoDescricaoBanco(descricao) {
        return http.get("/produto/prefixo/"+encodeURIComponent(descricao));
    }

    searchByTermo(termo) {
        return http.get("/produto/lista/"+encodeURIComponent(termo));
    }
}